import { apiProvider, apiClient } from './utilities/Provider';

// apiClient, not apiProvider, so HTTP errors reject.
const post = (resource, body) => apiClient.post(`/${resource}`, body).then((r) => r.data);

const login = (email, password) =>
    post('account/login', { email, password, application: 'CyberJob' });

const getMe = () =>
    apiProvider.get('users/me');

const getProfile = () =>
    apiClient.get('/account/me').then((r) => r.data);

const verifyTwoFactorLogin = (pendingToken, code) =>
    post('account/2fa/verify-login', { pendingToken, code });

const resendTwoFactorLoginCode = (pendingToken) =>
    post('account/2fa/resend-login-code', { pendingToken });

const setupTwoFactor = () =>
    post('account/2fa/setup');

const confirmTwoFactor = (code) =>
    post('account/2fa/confirm', { code });

const sendEmailTwoFactorSetupCode = () =>
    post('account/2fa/email/send-code');

const confirmEmailTwoFactor = (code) =>
    post('account/2fa/email/confirm', { code });

const disableTwoFactor = ({ password, code }) =>
    post('account/2fa/disable', { password, code });

const AccountService = {
    login,
    getMe,
    getProfile,
    verifyTwoFactorLogin,
    resendTwoFactorLoginCode,
    setupTwoFactor,
    confirmTwoFactor,
    sendEmailTwoFactorSetupCode,
    confirmEmailTwoFactor,
    disableTwoFactor,
};

export default AccountService;
